import { call, fork, put, select, take } from 'redux-saga/effects';
import { usersReducer } from './reducer';
import apiService from '../../api/apiServices/apiService';
import { toast } from 'react-toastify';
import type { UserDto as User } from '@poker-stats/contracts';
import { selectSearchEmail, selectSort } from './selectors';

function* watchLoadUsers() {
  while (true) {
    yield take(usersReducer.actions.loadUsers.type);

    const search: ReturnType<typeof selectSearchEmail> = yield select(selectSearchEmail);
    const sort: ReturnType<typeof selectSort> = yield select(selectSort);

    const { success, reject } = yield call(
      [apiService, apiService.getUsers],
      search,
      sort && sort.sortKey ? sort.sortKey : undefined,
      sort && sort.sortOrder ? sort.sortOrder : undefined,
    );

    if (success) {
      yield put(usersReducer.actions.setLoadedUsers(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchActivateUser() {
  while (true) {
    const { payload }: ReturnType<typeof usersReducer.actions.activateUser> = yield take(
      usersReducer.actions.activateUser.type,
    );

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.activateUser],
      payload,
    );

    if (success) {
      yield put(usersReducer.actions.activateUserSuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchChangeUserAvailablePokersiteIds() {
  while (true) {
    const { payload }: ReturnType<typeof usersReducer.actions.changeUserAvailablePokersiteIds> =
      yield take(usersReducer.actions.changeUserAvailablePokersiteIds.type);

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.changeUserAvailablePokersiteIds],
      payload.id,
      payload.availablePokersiteIds,
    );

    if (success) {
      yield put(usersReducer.actions.changeUserAvailablePokersiteIdsSuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchChangeUserSubscription() {
  while (true) {
    const { payload }: ReturnType<typeof usersReducer.actions.changeUserSubscription> = yield take(
      usersReducer.actions.changeUserSubscription.type,
    );

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.changeUserSubscription],
      payload.id,
      payload.subscription,
    );

    if (success) {
      yield put(usersReducer.actions.changeUserSubscriptionSuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchChangeUserSubscriptionDate() {
  while (true) {
    const { payload }: ReturnType<typeof usersReducer.actions.changeUserSubscriptionDate> =
      yield take(usersReducer.actions.changeUserSubscriptionDate.type);

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.changeUserSubscriptionDate],
      payload.id,
      payload.subscriptionDate,
    );

    if (success) {
      yield put(usersReducer.actions.changeUserSubscriptionDateSuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* usersSaga() {
  yield fork(watchLoadUsers);
  yield fork(watchActivateUser);
  yield fork(watchChangeUserAvailablePokersiteIds);
  yield fork(watchChangeUserSubscription);
  yield fork(watchChangeUserSubscriptionDate);
}
